var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('TableWrapper',{attrs:{"name":"tbl_finance_deposit","columns":_vm.columns,"url":_vm.url,"mod-count":_vm.modCount,"search-form-fields":_vm.formFields,"offset-height":_vm.offsetHeight,"show-column-visible":true,"show-add":false},on:{"on-ready":_vm.onReady}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }